var _rect, _rect2, _rect3, _rect4, _rect5, _polygon, _polygon2, _polygon3, _polygon4, _rect6, _rect7, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoDataHubBlack = function SvgLogoDataHubBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 264 120",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 178.8005,
    y: 30.8852,
    width: 6.5468,
    height: 32.7341,
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 207.17,
    y: 30.8852,
    width: 6.5468,
    height: 32.7341,
    fill: "#1d1d1b"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 227.434,
    y: 29.8876,
    width: 7.0354,
    height: 52.3745,
    fill: "#1d1d1b"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 112.9916,
    y: 15.1729,
    width: 32.1395,
    height: 89.7849,
    fill: "#f1a91d"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 70.3105,
    y: 15.1729,
    width: 31.4581,
    height: 89.7849,
    fill: "#f1a91d"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "62.828 119.922 47.864 119.922 47.864 104.958 51.605 104.958 51.605 116.181 62.828 116.181 62.828 119.922",
    fill: "#1d1d1b"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "47.864 15.173 47.864 0.209 62.828 0.209 62.828 3.95 51.605 3.95 51.605 15.173 47.864 15.173",
    fill: "#1d1d1b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.577 15.173 167.577 0.209 152.613 0.209 152.613 3.95 163.836 3.95 163.836 15.173 167.577 15.173",
    fill: "#1d1d1b"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "167.577 104.958 167.577 119.922 152.613 119.922 152.613 116.181 163.836 116.181 163.836 104.958 167.577 104.958",
    fill: "#1d1d1b"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 57.5575,
    y: 55.0587,
    width: 100.3265,
    height: 8.7476,
    fill: "#fcd479"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.166,
    y: 29.8876,
    width: 6.5468,
    height: 52.3745,
    fill: "#1d1d1b"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.8005,66.9862h6.5468a11.1841,11.1841,0,0,0,21.8227,0h6.5468a17.614,17.614,0,0,1-34.9163,0Z",
    fill: "#1d1d1b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7805,29.8876h10.9113c8.7291,0,13.0937,6.5468,13.0937,13.0936s-4.3646,13.0936-13.0937,13.0936H237.7805V49.528h10.9113a6.5468,6.5468,0,1,0,0-13.0936H237.7805Z",
    fill: "#1d1d1b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4539,29.8876h6.5468c15.2759,0,19.64,13.0936,19.64,26.1872s-4.3645,26.1873-19.64,26.1873H10.4539V75.7153h6.5468c6.5468,0,13.0936-4.3646,13.0936-19.64s-6.5468-19.64-13.0936-19.64H10.4539Z",
    fill: "#1d1d1b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M237.7805,82.2621h10.9113c10.9114,0,15.2759-7.6848,15.2759-15.2759S257.4209,51.71,248.6918,51.71H237.7805v6.5468h10.9113c6.5469,0,8.7291,4.3646,8.7291,8.7291,0,4.0295-2.1822,8.7291-8.7291,8.7291H237.7805Z",
    fill: "#1d1d1b"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoDataHubBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logoDataHubBlack.a2dba538ffb80ccb26d4a3006ce88da9.svg";